<template>
    <el-dialog
      width='433px'
      :visible='dialogVisible'
      @close='close'
    >
    <div class='title-base'>
      <!-- <div class='title-group' @click='title1Click'>
        <div :class='classStyle.title1'> {{title1}} </div>
        <div :class='classStyle.line1'></div>
      </div> -->
      <div class='title-group' @click='title2Click'>
       <div :class='classStyle.title2'> {{title2}} </div>
       <div :class='classStyle.line2'></div>
      </div>
    </div>

    <appScanLayer v-show='classStyle.pop2' v-bind:qrcodeUrl='appScanUrl'></appScanLayer>
    </el-dialog>
</template>

<script>
import cookie from '../../common/cookie'
import { Message } from 'view-design'
import appScanLayer from './appScanLoginLayer'
import moibleLayer from './mobileLoginLayer'
import { loginApi } from '@/components/login/login'

export default {
  name: 'loginPopup',
  data () {
    return {
      classStyle: {
        title1: 'title1 no_check_title',
        title2: 'title2',
        line1: 'titleLine no_check_line',
        line2: 'titleLine',
        pop1: false,
        pop2: true
      },
      appScanUrl: '',
      qrcodeSession: '',
      timer: null
    }
  },
  props: {
    title1: {
      type: String,
      default: '手机登录'
    },
    title2: {
      type: String,
      default: '快速登录'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    cookie,
    appScanLayer,
    moibleLayer
  },
  methods: {
    title1Click () {
      this.classStyle.title1 = 'title1'
      this.classStyle.line1 = 'titleLine'
      this.classStyle.title2 = 'title2 no_check_title'
      this.classStyle.line2 = 'titleLine no_check_line'
      this.classStyle.pop1 = true
      this.classStyle.pop2 = false
    },
    title2Click () {
      this.classStyle.title1 = 'title1 no_check_title'
      this.classStyle.line1 = 'titleLine no_check_line'
      this.classStyle.title2 = 'title2'
      this.classStyle.line2 = 'titleLine'
      this.classStyle.pop1 = false
      this.classStyle.pop2 = true
    },
    async qrcodeRefresh () {
      let result = await loginApi.qrcodeRefresh()
      this.appScanUrl = result.data.url
      this.qrcodeSession = result.data.token
      this.qrcodeScanPolling()
    },
    qrcodeScanPolling () {
      let req = {}
      req.token = this.qrcodeSession
      if (!this.timer) {
        this.timer = setInterval(async () => {
          let result = await loginApi.qrcodeLoginPolling(req)
          if (result.code !== 100001) {
            clearInterval(this.timer) // 清除定时器
            this.timer = null
            if (result.code === 0) {
              cookie.clearToken()
              cookie.setUserMsg(result.data.nickName)
              cookie.setToken(result.data.session)
              this.$emit('login_success', result.data.nickName)
              this.$emit('close')
              Message.info('登录成功')
            } else {
              Message.error(result.msg)
            }
          }
        }, 1000)
      }
    },
    close () {
      clearInterval(this.timer)
      this.timer = null
      this.$emit('close')
    }
  }
}
</script>

<style>
    .el-dialog {
      border-radius: 15px;
      margin: 0 !important;
    }
    .el-dialog__header {
      padding: 20px 20px 20px 20px !important;
      border-bottom: 1px solid #f4f4f4;
    }
    .el-dialog__body {
      padding: 0px 20px !important;
      transform: translate3d(0, 0, 0);
      overflow: auto;
      height: 90%;
    }
    .el-dialog__wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .title-base {
      width: 100%;
      display: inline-block;
      text-align: center;
    }
    .title-group {
      /* width: 40%; */
      width:70%;
      display: inline-block;
      cursor: pointer;
    }
    .titleLine {
      padding-bottom: 10px;
      border-top: 1px solid #FC5E4C;
      opacity: 1;
    }
    .title1 {
      height: 32px;
      opacity: 1;
      font-size: 16px;
      font-family: PingfangScBold;
      font-size: 20px;
    }
    .title2 {
      height: 32px;
      opacity: 1;
      font-size: 16px;
      font-family: PingfangScBold;
      font-size: 20px;
    }
    .no_check_title {
      color:#737689;
    }
    .no_check_line {
      border-top: 1px solid #cecece;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/popup/loginPopup.vue